<!-- src/components/ViewChildPopup.vue -->
<template>
  <div class="popup-modal">
    <div class="popup-header d-flex justify-content-between align-items-center">
    <h5 class="mb-0" style="margin-top: -8px;">Selected Activities</h5>
      <button class="btn btn-close" style="margin-top: -23px;" @click="$emit('close')"></button>
    </div>
    <div class="table-scroll-wrapper">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th
              v-for="(col, index) in mappingColumns.configs"
              :key="index"
              :style="{ textAlign: col.textAlign || 'center' }"
            >
              {{ col.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="displayActivities.length === 0">
            <td :colspan="mappingColumns.configs.length" class="text-center fw-bold py-3">
              No activities selected
            </td>
          </tr>
          <tr v-for="(activity, rowIdx) in editableActivities" :key="rowIdx">
            <td
              v-for="(col, colIdx) in mappingColumns.configs"
              :key="colIdx"
              :style="{ textAlign: col.textAlign || 'center' }"
            >
              <template v-if="col.name === 'Mapping Name'">
                <input
                  type="text"
                  v-model="activity['Mapping Name']"
                  class="form-control"
                  :placeholder="col.label"
                  style="font-size: inherit;"
                  @click.stop
                />
              </template>
              <template v-else>
                {{ activity[col.name] || 'N/A' }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="popup-footer text-center">
      <button class="btn btn-primary" @click="addActivities">Add Activities</button>
      <button class="btn btn-primary" style="
    margin-left: 10px;" @click="submitActivities">Submit</button>
    </div>
  </div>
</template>

<script>
import { pageViews, type } from '@/utils/util';
import { getCookie } from "../../store/cookie.js";
import { makeOpearationRequest } from "@/services/apiServices";
import { toast } from "vue3-toastify"; // <-- add this import

export default {
  name: pageViews.VIEW_CHILD_ACTIVITIES_POPUP,
  props: {
    selectedActivities: {
      type: Array,
      default: () => [],
    },
    childActivityViewData: {
      type: [Array, Object],
      default: null,
    },
    projectParamId: {
      type: String,
      default: "",
    },
    
  },
  data() {
    return {
      mappingColumns: {
        type: type.CHILD_ACTIVITY_VIEW,
        isMultiSelectionAllowed: true,
        defaultSortOrder: { name: "asc", label: "Ascending" },
        defaultSortColumn: { name: "Process", label: "Process" },
        configs: [
          { name: "Use Case Location", label: "Use Case Location", order: 0, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "Use Case", label: "Use Case", order: 1, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "Process Location", label: "Process Location", order: 2, isSortable: true, defaultSelected: false, textAlign: "left" },
          { name: "Process", label: "Process", order: 3, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "Activity", label: "Activity", order: 4, isSortable: true, defaultSelected: true, textAlign: "left" },
          { name: "Mapping Name", label: "Mapping Name", order: 5, isSortable: true, defaultSelected: true, textAlign: "left" }
        ]
      },
      editableActivities: [],
    };
  },
  computed: {
    displayActivities() {
      // Use API response if available, else fallback to selectedActivities
      if (Array.isArray(this.childActivityViewData) && this.childActivityViewData.length > 0) {
        return this.childActivityViewData;
      }
      // If API returns object with data property
      if (this.childActivityViewData && Array.isArray(this.childActivityViewData.data)) {
        return this.childActivityViewData.data;
      }
      return this.selectedActivities;
    }
  },
  watch: {
    displayActivities: {
      immediate: true,
      handler(val) {
        // Deep clone to avoid mutating props
        this.editableActivities = (val || []).map(item => ({ ...item }));
      }
    }
  },
  methods: {
    addActivities() {
      this.$emit('add-activities');
    },
    async submitActivities() {
      // Use editableActivities for submission

      // Get Request Id from first row if available, fallback to prop
      let reqId = this.projectParamId;
      if (this.editableActivities && this.editableActivities.length > 0) {
        const firstReqId = this.editableActivities[0]["Request Id"];
        if (firstReqId) {
          reqId = firstReqId;
        }
      }

      const input = (this.editableActivities || []).map(act => ({
        activityId: act["activityId"] || act["Activity Id"] || act["Activity"],
        mappingName: act["mappingName"] || act["Mapping Name"],
        projectParamId: act["Request Id"],
      })).filter(item => item.activityId && item.mappingName);
      if (!input.length) {
        console.error("No valid activities to submit.");
        return;
      }

      const payload = {
        userId: getCookie("userId"),
        type: "mapper.MAPPER_SAVE_CHILD_ACTIVITY",
        requestId: reqId,
        input
      };

      console.log("Submitting child activities payload:", payload);

      try {
        const response = await makeOpearationRequest(this.$acclConfigs, "/savedChildActivity", payload);
        console.log("Response from save child activities:", response);
        if (response.status === 200 && response.data ) {
          this.editableActivities = []; // Clear editable activities after successful save
          toast('<i class="fa-solid fa-thumbs-up fa-bounce"></i> Mapping job created successfully.', {
            autoClose: 3000,
            dangerouslyHTMLString: true
          });
          this.$emit('close');
          this.$emit('clear-selection'); // <-- emit clear-selection event
          console.log("Child activities saved successfully", response.data);
        } else {
          toast.error("Failed to save child activities.", {
            autoClose: 5000
          });
        }
      } catch (e) {
        toast.error("Error saving child activities.", {
          autoClose: 5000
        });
      }
    },
  },
};
</script>

<style scoped>
.popup-modal {
  position: fixed;
  top: 7%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  width: 93%;
  overflow: hidden;
  padding: 1rem 1rem 0 1rem;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1050;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  max-height: 80vh;
}

/* Fixed header */
.popup-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 2;
  width: 101%;
}

/* Scrollable table body */
.table-scroll-wrapper {
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: 50vh;
  margin-bottom: 1rem;
  width: 101%;
}

/* Fixed footer */
.popup-footer {
  position: sticky;
  bottom: 0;
  background: white;
  z-index: 2;
}

/* Table layout fixed for constant column width */
table.table-bordered {
  width: 100%;
  table-layout: fixed;
  word-break: break-word;
}

/* Ensure table cells wrap text and don't overflow */
table.table-bordered th,
table.table-bordered td {
  white-space: normal;
  word-break: break-word;
  max-width: 200px;
  overflow-wrap: break-word;
}

/* New style for table header columns */
table.table-bordered thead th {
  background-color: #da6a26;
  color: whitesmoke;
}
/* New style for submit button */
button.btn-primary {
  background-color: #1D2856 !important;
}
.is-invalid {
  border-color: #dc3545 !important;
}
.invalid-feedback {
  color: #dc3545;
  font-size: 0.85em;
  margin-top: 2px;
}
</style>
